import ExclusiveGateway from '../svg/ExclusiveGateway.svg'
import ParallelGateway from '../svg/ParallelGateway.svg'
import InclusiveGateway from '../svg/InclusiveGateway.svg'

export const GATE_WAY = {
  // 普通网关
  'bpmn:ExclusiveGateway': ExclusiveGateway,
  // 同步网关
  'bpmn:ParallelGateway': ParallelGateway,
  // 条件同步网关
  'bpmn:InclusiveGateway': InclusiveGateway,
}

import Parallel from '../svg/Parallel.svg'
import Serial from '../svg/Serial.svg'

export const APPROVER_TYPE = {
  serial: Serial,
  parallel: Parallel,
  normal: '',
}
